const viewModes = {
    VIEW: 'view',
    EDIT: 'edit',
    FIND: 'find',
}

export default viewModes;